// extracted by mini-css-extract-plugin
module.exports = {"tootorBg":"Courses_tootorBg__2LI0H","titleCard":"Courses_titleCard__KEARO"};